import * as React from 'react';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import GlobalStyles from '@mui/material/GlobalStyles';
import Container from '@mui/material/Container';
import { useHistory } from 'react-router-dom';
import { SessionContext } from '../context/Session';

function AccountView() {
  let history = useHistory();
  const { allRoutes } = React.useContext(SessionContext);

  React.useEffect(() => {
    console.log(allRoutes);
  }, []);

  return (
    <React.Fragment>
      <GlobalStyles
        styles={{ ul: { margin: 0, padding: 0, listStyle: 'none' } }}
      />
      <CssBaseline />
      <Container
        disableGutters
        maxWidth='sm'
        component='main'
        sx={{
          display: 'flex',
          width: '100%',
          marginTop: 2,
          alignItems: 'center',
          justifyContent: 'space-around',
          flexDirection: 'column',
        }}
      >
        <Typography
          component='h1'
          variant='h2'
          align='center'
          color='primary'
          gutterBottom
        >
          My Account
        </Typography>
      </Container>
    </React.Fragment>
  );
}

export default function Pricing() {
  return <AccountView />;
}
